// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1rTg0","resendInfoText":"OnGoingPaymentBox_resendInfoText__3I-Y3"};